// CookieConsentPopup.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CookieConsentPopup = ({ onAccept, onReject, onConfigure, policyUrl = '/ca/politica-de-cookies' }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        // Verificar si el usuario ya ha dado consentimiento
        const hasConsented = localStorage.getItem('cookieConsent');
        if (!hasConsented) {
            // Mostrar con pequeño delay para mejor UX
            const timer = setTimeout(() => setIsVisible(true), 500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setIsVisible(false);
        onAccept?.();
    };

    const handleReject = () => {
        localStorage.setItem('cookieConsent', 'rejected');
        setIsVisible(false);
        onReject?.();
    };

    const handleConfigure = () => {
        onConfigure?.();
        // Opcional: abrir modal de configuración detallada
    };

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-overlay" onClick={handleClose}>
            <div
                className="cookie-popup"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="cookie-title"
            >
                <button
                    className="cookie-close"
                    onClick={handleClose}
                    aria-label="Tancar"
                >
                    ×
                </button>

                <h2 id="cookie-title" className="cookie-title">
                    {t("Configuración de cookies")}
                </h2>

                <p className="cookie-description">
                    {t("Aquí puedes ver y personalizar la información que recopilamos sobre los usuarios.")}
                    {t("Para obtener más información, accede a nuestra")}{" "}
                    <a href={policyUrl} target="_blank" rel="noopener noreferrer">
                        {t("Política de cookies")}
                    </a>
                </p>

                <div className="cookie-categories">
                    <div className="cookie-category">
                        <div className="category-header">
                            <span className="category-name">{t("Necesarias")}</span>
                            <span className="category-status required">{t("Siempre activas")}</span>
                        </div>
                        <p className="category-description">
                            {t("Estas cookies son necesarias para el funcionamiento de nuestro sitito web")}.
                        </p>
                    </div>

                    <div className="cookie-category">
                        <div className="category-header">
                            <span className="category-name">{t("Analíticas")}</span>
                            <label className="toggle-switch">
                                <input
                                    type="checkbox"
                                    defaultChecked={isExpanded}
                                    onChange={(e) => setIsExpanded(e.target.checked)}
                                />
                                <span className="toggle-slider"></span>
                            </label>
                        </div>
                        <p className="category-description">
                            {t("Almacenamos cookies con Google Analytics para elaborar estadísticas sobre el tránsito y volumen de visitas del sitio web")}.
                        </p>
                    </div>
                </div>

                <div className="cookie-actions">
                    {/* <button
                        className="boton boton-configure"
                        onClick={handleConfigure}
                    >
                        {t("Configurar")}
                    </button>*/}
                    <button
                        className="boton boton-reject"
                        onClick={handleReject}
                    >
                        {t("Rechazar")}
                    </button>
                    <button
                        className="boton boton-accept"
                        onClick={handleAccept}
                    >
                        {t("Aceptar")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsentPopup;
